import { ValidationSchema } from '../../../../../../../validations/interfaces';
import PropertyOwnerBusinessNameValidation from './PropertyOwnerBusinessNameValidation';
import PropertyOwnerEmailValidation from './PropertyOwnerEmailValidation';
import PropertyOwnerPercentOwnedValidation from './PropertyOwnerPercentOwnedValidation';
import PropertyOwnerPhoneNumberValidation from './PropertyOwnerPhoneNumberValidation';
import PropertyOwnerRelatedToBorrowerValidation from './PropertyOwnerRelatedToBorrowerValidation';
import SystemPropertyRecordTypeValidation from './SystemPropertyRecordTypeValidation';
import { Validation } from '../../../../../../../validations/Validation';
import * as Yup from 'yup';
import PropertyOwnerFirstNameValidation from './PropertyOwnerFirstNameValidation';
import PropertyOwnerLastNameValidation from './PropertyOwnerLastNameValidation';
import PropertyLandlordConsentValidation from './PropertyLandlordConsentValidation';

export class PropertyOwnerValidation implements ValidationSchema {
  public name = 'principals';
  public label = '';
  public dependsOn: string[] = [];
  public type = 'array';
  public required = {
    message: '',
    value: false,
  };
  public nullable = false;

  public when(schema: Yup.ArraySchema<Yup.ObjectSchema<any>>) {
    const validations = [
      PropertyOwnerBusinessNameValidation,
      PropertyOwnerPhoneNumberValidation,
      PropertyOwnerRelatedToBorrowerValidation,
      PropertyOwnerEmailValidation,
      PropertyOwnerPercentOwnedValidation,
      SystemPropertyRecordTypeValidation,
      PropertyOwnerFirstNameValidation,
      PropertyOwnerLastNameValidation,
      PropertyLandlordConsentValidation,
    ];
    const validationSchema: Record<string, any> = validations.reduce(
      (schema, validation) => {
        schema[validation.name] = validation.buildSchema();
        return schema;
      },
      {}
    );

    return schema.of(Yup.object().shape(validationSchema)).required();
  }
}
export default new Validation(new PropertyOwnerValidation());
